import { render, staticRenderFns } from "./MinimalInterface.vue?vue&type=template&id=06e18ebf"
import script from "./MinimalInterface.vue?vue&type=script&lang=js"
export * from "./MinimalInterface.vue?vue&type=script&lang=js"
import style0 from "./MinimalInterface.vue?vue&type=style&index=0&id=06e18ebf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports